import React from "react";
import { TextField } from "@mui/material";
import pullListLabels from "../../util/PullListLabels";
import HistoryLogElement from "./HistoryLogElement";
import GroupAllUsers from "../FieldTags/GroupAllUsers";

const EPUpdate = ({ epUpdate, handleChange, pullLists, informedConsent, informedConsentApprover, shipmentFromRepo, sampleDisposal }) => {
    const canEdit = (shipmentFromRepo === "No" && sampleDisposal === "No") || (informedConsent !== "No" && informedConsentApprover !== "No");

    return (
        <div className="planField">
            <GroupAllUsers />
            <TextField
                id="epUpdate-field"
                name="epUpdate"
                label={pullListLabels.epUpdate}
                InputLabelProps={{ shrink: true }}
                type="text"
                value={epUpdate ? epUpdate : ""}
                onChange={(e) => handleChange("epUpdate", e.target.value)}
                multiline
                minRows={1}
                className="fullLength"
                disabled={!canEdit}
            />
            <HistoryLogElement pullLists={pullLists} label={"epUpdate"} />
        </div>
    );
};

export default EPUpdate;